import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { sectionKeys } from '../../config/statBlockLayout';

function hasValue(v) {
  if (v === undefined || v === null || v === '') return false;
  if (Array.isArray(v)) return v.length > 0;
  return true;
}

/**
 * One heading of a creature's stat block (issue 1591): the system's declared
 * heading (Defense, Offense, …) over the sections it holds, open or closed as
 * the layout says and collapsible, as the tabletop draws it. A heading this
 * entry has nothing under is not drawn. Closed hides its body on screen only:
 * the printed page carries every stat.
 */
export default function StatHeading({ section, values, variant, children }) {
  const [open, setOpen] = useState(section.open);
  if (!sectionKeys(section).some((k) => hasValue(values[k]))) return null;
  const bodyId = `stat-heading-${section.key}`;
  const toggle = (
    <button
      type="button"
      className="stat-heading-toggle"
      aria-expanded={open}
      aria-controls={bodyId}
      onClick={() => setOpen((o) => !o)}
    >
      {open ? <ChevronDown className="w-4 h-4" aria-hidden="true" /> : <ChevronRight className="w-4 h-4" aria-hidden="true" />}
      <span>{section.heading}</span>
    </button>
  );
  const body = (
    <div id={bodyId} className="stat-heading-body" data-open={open ? 'true' : 'false'}>
      {children}
    </div>
  );
  if (variant === 'stat-block') {
    return (
      <div className="stat-heading" data-testid="stat-heading" data-heading={section.key}>
        <hr className="stat-block-divider" />
        <h2 className="stat-heading-title">{toggle}</h2>
        {body}
      </div>
    );
  }
  return (
    <div className="stat-heading space-y-6" data-testid="stat-heading" data-heading={section.key}>
      <h2 className="stat-heading-title section-header">{toggle}</h2>
      {body}
    </div>
  );
}
